import { Component, OnInit, Input } from '@angular/core';
import { LightboxConfig, Lightbox } from 'ngx-lightbox';

@Component({
  selector: 'app-lightelement',
  templateUrl: './lightelement.component.html',
  styleUrls: ['./lightelement.component.scss']
})
export class LightelementComponent implements OnInit {
  @Input() _albums:Array<any>;

  //lightboxSource:Array<any> = ["../../assets/img/VOCALENSEMBLE.jpg","../../assets/img/VOCALENSEMBLE.jpg"];
  lightboxSource:Array<any>;

  constructor(private _lighboxConfig: LightboxConfig, private _lightbox: Lightbox) {
    console.log( this._albums );
  }
  
  open() {
    this._lightbox.open( this.lightboxSource, 0, { wrapAround: true, showImageNumberLabel: false });
  }
  
  ngOnInit() { 
    this.lightboxSource = this._albums;
    console.log( "ngOnInit", this );
  }

}
